export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2019.a7c4ac5c.pdf";